import queryString from 'query-string'
import 'whatwg-fetch'
import {
    apiURL
} from './Base';

var isInitChannel = null;

const jsonPipe = response => response.json();

const truncate = (str, no_words) => str.split(" ").splice(0, no_words).join(" ");

const truncate_chars = (str, chars) => {
    let charsArray = "";
    for (let i = 0; i < chars; i++) {
        if (!str[i]) continue;
        charsArray += str[i];
    }
    return charsArray;
}

const usingAPI = {
    InitChannel: () => {
        if (isInitChannel) return isInitChannel;
        isInitChannel = fetch(`${apiURL}getChannel`).then(jsonPipe);
        return isInitChannel;
    },
    getTopStory: async callback => {
        let data = await usingAPI.InitChannel();
        data = data.components.filter(k => k.name == "TopStory")[0];

        const dataModel = {
            Title: data.title,
            Desc: data.sub_title,
            Link: data.link_data.href,
            Image: {
                source: data.media_data.items[0].src,
                credit: data.media_data.items[0].credit,
            }
        }
        return callback ? callback(dataModel) : dataModel;
    },
    getLatestVideos: async callback => {
        let data = await usingAPI.InitChannel();
        data = data.components.filter(k => k.name == "MultiImageLinksAuto")[0].items;
        let dataModel = [];
        data.forEach(obj => {
            dataModel.push({
                Title: truncate_chars(obj.title, 27) + "...",
                Desc: obj.sub_title,
                Link: obj.link_data.href,
                Image: {
                    source: obj.img_data.src,
                    credit: obj.img_data.credit
                }
            })
        });

        return dataModel;
    },
    getLatestArticles: async callback => {
        let data = await usingAPI.InitChannel();
        data = data.components.filter(k => k.name == "ArticleHeadlines")[0].items;
        let dataModel = [];

        data.forEach(obj => {
            dataModel.push({
                Title: truncate_chars(obj.title, 75),
                Desc: `${truncate_chars(obj.sub_title, obj.title.length >= 60 ? 30 : 60)}...`,
                Link: obj.link_data.href,
                Author: obj.link_data.article_data.author,
                DateCreated: obj.link_data.article_data.pub_date,
                Image: {
                    source: obj.img_data.src,
                    credit: obj.img_data.credit
                }
            })
        });

        return dataModel;
    }
}

export {
    usingAPI
}


// WEBPACK FOOTER //
// ./src/Components/Services/FetchService.js